module.exports = __webpack_public_path__ + "img/m-oil.514bd67d.webp";